var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
define(["require", "exports", "hypo_elements/Typescripts/UuidService/UuidService", "hypo_elements/Typescripts/GoogleAnalyticsTrackingService/GoogleAnalyticsTrackingService", "hypo_elements/Typescripts/SendEvent/CheckSendEvent", "jquery", "jquery-ui/ui/widgets/datepicker"], function (require, exports, UuidService, GoogleAnalyticsTrackingService, CheckSendEvent) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    UuidService = __importStar(UuidService);
    GoogleAnalyticsTrackingService = __importStar(GoogleAnalyticsTrackingService);
    CheckSendEvent = __importStar(CheckSendEvent);
    $(function () {
        var uuidPromise = UuidService.getUuid();
        var $fondsantrag = $(".fondsantrag");
        var $fondsantragForm = $fondsantrag.find(".fondsantrag_form");
        var $confirmationDialog = $fondsantrag.find(".fondsantrag_confirmationDialog");
        var $errorDialog = $fondsantrag.find(".fondsantrag_errorDialog");
        var url = "/rest-api/leads/fonds";
        var formNameForTracking = "fondsantrag";
        if (CheckSendEvent.sentEvent('fondsantrag')) {
            uuidPromise.done(function (uuid) {
                GoogleAnalyticsTrackingService.submitCheckoutTracking(uuid, formNameForTracking);
            });
        }
        initializeDatepicker($fondsantrag);
        $fondsantragForm.each(function (index, element) {
            var $form = $(element);
            $form.submit(function (event) {
                var form = $(event.target);
                var formData = {
                    "anrede": form.find("input[name=anrede]:checked").val(),
                    "vorname": form.find("input[name=vorname]").val(),
                    "nachname": form.find("input[name=nachname]").val(),
                    "geburtsdatum": form.find("input[name=geburtsdatum]").val(),
                    "strasse": form.find("input[name=strasse]").val(),
                    "hausnummer": form.find("input[name=hausnummer]").val(),
                    "plz": form.find("input[name=plz]").val(),
                    "ort": form.find("input[name=ort]").val(),
                    "email": form.find("input[name=email]").val(),
                    "telefonNummer": form.find("input[name=telefonNummer]").val(),
                    "mitteilung": form.find("textarea[name=mitteilung]").val(),
                    "anmeldungNewsletter": form.find("input[name=anmeldungNewsletter]").prop("checked"),
                    "zustimmungAgb": form.find("input[name=zustimmungAgb]").prop("checked"),
                    "wunschberaterNameUid": form.find("input[name=wunschberaterNameUid]").val(),
                };
                uuidPromise
                    .done(function (uuid) {
                    submitForm(formData, uuid);
                })
                    .fail(function () {
                    handleFailedSubmit();
                    uuidPromise = UuidService.getUuid();
                })
                    .always(function () {
                    event.preventDefault();
                });
            });
            function submitForm(formData, uuid) {
                formData.uuid = uuid;
                $.ajax({
                    type: "POST",
                    url: url,
                    contentType: "application/json",
                    data: JSON.stringify(formData),
                })
                    .done(handleSuccessfulSubmit)
                    .fail(handleFailedSubmit);
            }
            function handleSuccessfulSubmit() {
                uuidPromise.done(function (uuid) {
                    GoogleAnalyticsTrackingService.submitPurchaseTracking(uuid, formNameForTracking);
                });
                $errorDialog.hide();
                $form.hide();
                $confirmationDialog.show();
                $form.trigger("reset");
            }
            function handleFailedSubmit() {
                $confirmationDialog.hide();
                $errorDialog.show();
            }
        });
        function initializeDatepicker($antrag) {
            var $geburtsdatumField = $antrag.find("input[name='geburtsdatum']");
            var currentYear = new Date().getFullYear();
            $geburtsdatumField.datepicker("option", "yearRange", currentYear - 99 + ":" + currentYear);
            $geburtsdatumField.datepicker("option", "changeYear", true);
        }
    });
});
